import { render, staticRenderFns } from "./AccountInvestigationModal.vue?vue&type=template&id=ec5fbede&scoped=true"
import script from "./AccountInvestigationModal.vue?vue&type=script&lang=js"
export * from "./AccountInvestigationModal.vue?vue&type=script&lang=js"
import style0 from "./AccountInvestigationModal.vue?vue&type=style&index=0&id=ec5fbede&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec5fbede",
  null
  
)

export default component.exports